<template>
  <v-col cols="12" class="pa-12 file-wrapper-after file-wrapper-before"
    @dragover="dragover" @dragleave="dragleave" @drop="drop" >
    <input class="files-button" type="file"
      name="fields[assetsFieldHandle][]"
       disabled="disabled"
      id="assetsFieldHandle" @change="onChange"
      ref="file" :accept="allowedTypes"/>

    <label for="assetsFieldHandle" class=" block cursor-pointer">
      <v-icon v-if="!this.filelist.length" size="50">icons8-drag-and-drop</v-icon>
      <div v-if="!this.filelist.length">
      {{$t('buttons.dragAndDrop')}}
      </div>
    </label>
    <div v-if="filelist[0] != undefined">
      <v-img v-if="filelist[0].type === 'image/jpeg' || filelist[0].type === 'image/png' || filelist[0].type === 'image/jpg'"
          class="mx-auto my-2"
          height="268"
          width="356"
          :src="fileURL"
        />
    </div>
    <v-list rounded v-if="this.filelist.length" :max-width="maxWidth" v-cloak>
      <v-list-item v-for="(file, index) in filelist" :key="index">
        <v-list-item-content>
          <v-list-item-title v-text="file.name"></v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon>
          <appbutton :label="$t('buttons.removeFile')" icon="icons8-multiply" type="darkgrey" @click.native="remove(filelist.indexOf(file))"/>
        </v-list-item-icon>
      </v-list-item>
    </v-list>
    <v-row class="px-1 py-0 mb-0" :max-width="maxWidth" v-if="hideUploadButton === false && isUploading">
      <v-progress-linear v-model="uploadValue" height="25">
        <strong>{{ Math.ceil(uploadValue) }}%</strong>
      </v-progress-linear>
    </v-row>
  </v-col>
</template>

<script>
export default {
  name: "DragDrop",
  delimiters: ["${", "}"], // Avoid Twig conflicts
  props: {
    allowedTypes: {
      type: String,
    },
    storagePath: {
      type: String,
    },
    maxWidth: {
      type: String,
      default: 'auto'
    }
  },
  data() {
    return {
      isUploading: false,
      uploadValue: 0,
      filelist: [], // Store our uploaded files
      hideUploadButton: false,
      fileURL: ''
    };
  },
  methods: {
    onChange() {
      this.filelist = [...this.$refs.file.files];
    },
    remove(i) {
      this.filelist.splice(i, 1);
    },
    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains("file-wrapper-after")) {
        event.currentTarget.classList.remove("file-wrapper-before");
        event.currentTarget.classList.add("file-wrapper-after");
      }
    },
    dragleave(event) {
      // Clean up
      event.currentTarget.classList.add("file-wrapper-before");
      event.currentTarget.classList.remove("file-wrapper-after");
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add("file-wrapper-before");
      event.currentTarget.classList.remove("file-wrapper-after");

      this.isUploading = true; // show progress bar
      this.fileURL = null;
      var t = this;

      Array.from(this.filelist).forEach((file) => {
        //upload to storage
        if (t.storagePath != undefined){
            var name = t.storagePath + `/${file.name}`;
        }else {
            var name = file.name;
        }
        //GCS storage reference
        const storageRef = t.$firebase.storage.ref().child(name).put(file);
       
        storageRef.on( `state_changed`, (snapshot) => {
            t.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100; //upload progress
          }, 
          (error) => { console.log(error.message); },
          () => {
            t.uploadValue = 100; // upload value after loading file
            t.isUploading = false;
            storageRef.snapshot.ref.getDownloadURL().then((url) => {
              t.fileURL = url; // asign GCS url to fileURL
              // console.log(t.fileURL);
              // * adding the uploaded file to the store
               // Create the file metadata
               var storeFile = {
                fileName: file.name,
                fileSize: file.size,
                fileType: file.type,
                fileURL: t.fileURL
              }
              t.$store.commit("upload_file_store/setFile", storeFile); 
            });
          }
        );
      });
    },
  },
};
</script>

<style>
.test {
  border: 5px solid salmon;
}

.file-wrapper-before {
  text-align: center;
  width: 100%;
  height: auto;
  vertical-align: middle;
  display: table-cell;
  position: relative;
  overflow: hidden;
  background: #ffffff; /* and other things to make it pretty */
  border: 2px dashed #d80010;
}
.file-wrapper-after {
  text-align: center;
  width: 100%;
  height: auto;
  vertical-align: middle;
  display: table-cell;
  position: relative;
  overflow: hidden;
  background: #ffffff; /* and other tther things to make it pretty */
  border: 2px dashed #4f4f4f;
}

.files-button {
  display: none;
}
</style>
